import { render } from "./FiltersChip.vue?vue&type=template&id=c1dd79cc&scoped=true"
import script from "./FiltersChip.vue?vue&type=script&lang=ts"
export * from "./FiltersChip.vue?vue&type=script&lang=ts"

import "./FiltersChip.vue?vue&type=style&index=0&id=c1dd79cc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c1dd79cc"

export default script